<template lang="pug">
  #system-error
    .container.body-width.pt-3
      b-card.mt-1.form-box.mx-auto.text-center.justify-content-center(body-class="px-5")
        h2.mt-5.font-weight-bold.text-muted.white-space
        p.mx-auto.mt-5.mb-3.white-space {{error_msg}}
        .mt-5
          router-link(:to="{name: 'TopPage'}") トップページに戻る
</template>

<script>
export default {
  name: "ApplicationError",
  props: {
    error_msg: {type: String, required: true}
  }
}
</script>

<style scoped>
  .body-width {
    max-width: 1200px;
  }
</style>